import { ROUTES } from 'utils/constants/routes';

export const VERIFICATION_OPTION = {
    SINGLE: 'SINGLE',
    AND: 'AND',
    OR: 'OR',
};

// When we want to pass verification type for conditional rendering of any function. to avoid any bug related to typo
export const VERIFICATION_TYPE = {
    GOVT_ID: 'govt_id',
    KBA: 'kba',
    FAOV: 'bank',
};

// Full-screen routes that hide the app footer (it would obstruct the content, e.g. the camera
// capture view and the embedded Finicity SDK). Append new pathnames here as more are added.
export const FOOTER_HIDDEN_ROUTES = [
    ROUTES.MOBILE_CAPTURE,
    ROUTES.BANK_CONNECT,
    ROUTES.GOVT_ID_V2_CAPTURE_CAMERA,
    ROUTES.GOVT_ID_V2_CAPTURE_SELFIE_LIVENESS,
];

// Routes that hide the app navbar so the embedded experience fills the screen unobstructed
// (e.g. the Finicity SDK). The route renders its own navbar around its loading screens instead.
export const NAVBAR_HIDDEN_ROUTES = [ROUTES.BANK_CONNECT];
